import { SizedBox } from "@/components/core/SizedBox";
import { TopArea } from "./TopArea";
import { Experiences } from "./Experiences";
import { Education } from "./Education";
import "@/pages/Home/style.css"
import { Skills } from "./Skills";
import { Projects } from "./Projects";
import { EnterBlog } from "./EnterBlog";

const Home = () => {
    return (
        <div className="home-view"
            style={{
                backgroundColor: 'var(--color-bg)',
            }}
        >
            <SizedBox height={10} />
            <TopArea />
            <SizedBox height={50} />
            <Skills />
            <SizedBox height={50} />
            <Education />
            <SizedBox height={50} />
            <Experiences />
            <SizedBox height={50} />
            <EnterBlog />
            <SizedBox height={50} />
            <Projects />
            <SizedBox height={50} />
        </div >
    );
}


export default Home;